import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import {
	INavbarNoticeState,
	IShowEmQrCodeInit,
	setNavbarNotices,
	showEmCooperation,
	showEmQrCodeInit,
	showNavbarProgress,
} from '../actions/navbar';

/**
 * ナビゲーションバーのState型
 */
interface INavbarShowState {
	isShowProgress?: boolean;
	isShowEmCooperation?: boolean;
}
export type INavbarState = INavbarNoticeState &
	IShowEmQrCodeInit &
	INavbarShowState;

/**
 * ナビゲーションバーのState初期値
 */
const initialState: INavbarState = {
	applyingCancelApplyCurriculumCnt: 0,
	applyingCancelApplyTrainingCnt: 0,
	applyingPerformanceApplyTrainingCnt: 0,
	applyingStudentApplyCurriculumCnt: 0,
	applyingStudentApplyTrainingCnt: 0,
	/** 法人コード */
	companyCode: '',
	/** QRコードURL */
	emRegistrationUrl: '',
	/** テナントID */
	emTenantId: '',
	/** エラーメッセージ */
	errorMessageList: [],
	/** QRコード表示フラグ */
	isShowEmCooperation: false,
	isShowProgress: false,
	/** QRコード */
	qrCodeBase64: '',
	/** 登録有効期限 */
	registrationExpirationDate: '',
	/** 連携結果 */
	resultFlg: false,
	/** Generalist/EMのログインURL */
	signinUrl: '',
	/** Generalist/EMのログインID */
	userId: '',
	waitingPerformanceApprovalCnt: 0,
	waitingStudentApprovalCnt: 0,
	waitingStudentCancelCnt: 0,
};

/**
 * ナビゲーションバー用reducer
 * @param state State
 * @param action アクション
 */
const navbar = (state = initialState, action: Action) => {
	if (isType(action, setNavbarNotices)) {
		return {
			...state,
			...action.payload.noticeState,
			setNoticeAt: new Date(),
		};
	}

	if (isType(action, showNavbarProgress)) {
		return {
			...state,
			isShowProgress: action.payload.isShow,
		};
	}

	if (isType(action, showEmCooperation)) {
		return {
			...state,
			isShowEmCooperation: action.payload.isShowEmCooperation,
		};
	}

	if (isType(action, showEmQrCodeInit)) {
		return {
			...state,
			...action.payload.emQrCodeInit,
		};
	}

	return state;
};

export default navbar;



// WEBPACK FOOTER //
// ./src/reducers/navbar.ts